<div class="{{width()}}">
    <div class="{{height()}} w-full rounded-full overflow-hidden" [style.background-color]="trackColor()"
        [style.border-radius]="borderRadius()">
        <div class="h-full rounded-full transition-all duration-300" [style.width.%]="percentage()"
            [style.background-color]="backgroundColor()" [style.border-radius]="borderRadius()">
        </div>
    </div>
</div>
